
import { useCallback } from "react";
import { speak, stopSpeaking } from "@/utils/speech";

export default function useSpeech() {
  const speakText = useCallback((text) => {
    speak(text);
  }, []);

  const stop = useCallback(() => {
    stopSpeaking();
  }, []);

  return {
    speak: speakText,
    stop,
  };
}
